import { setGADataLayer } from 'analytics'

export type LanguageChangePlacement = 'auth_segmented_control' | 'navigation_menu' | 'settings_locale_select'

export const trackLanguageChange = (
    previousLocale: string,
    selectedLocale: string,
    placement: LanguageChangePlacement
): void => {
    setGADataLayer({
        event: 'language_change',
        options: {
            previousLocale,
            selectedLocale,
            placement,
        },
    })
}
